import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { addPayrollPartnerRoute } from '../api/constants';
import { payrollpartnersList } from '../constants';

type useAddPayrollPartnerProps = {
    setErrorText: Dispatch<SetStateAction<string>>;
};

export const useAddPayrollPartner = ({
    setErrorText,
}: useAddPayrollPartnerProps) => {
    const client = useQueryClient();
    const { mutate: addPayrollPartner, isLoading: isAddingPayrollPartner } =
        useMutation({
            mutationFn: (variables: {
                email: string;
                name: string;
                company_name: string;
            }) =>
                axiosInstance
                    .post(addPayrollPartnerRoute, variables)
                    .then((res) => res.data),
            onSuccess: (data) => {
                if (data.status === 200) {
                    client.invalidateQueries([payrollpartnersList]);
                    setErrorText('');
                } else {
                    setErrorText(data?.message || errorMessage);
                }
            },
            onError: (error: { message?: string }) => {
                setErrorText(error?.message || errorMessage);
            },
        });

    return {
        addPayrollPartner,
        isAddingPayrollPartner,
    };
};
